module.exports = __webpack_public_path__ + "static/media/up.ad70cd00.svg";